import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);
const axios3 = new HttpRequest(process.env.VUE_APP_API_BASE_URL3);

export default {
    shareinfos(data) {
        return axios.request({
            url: "api/shareinfos",
            method: "post",
            data
        });
    },
    shareconfig(data) {
        return axios.request({
            url: "api/share-config",
            method: "post",
            data
        });
    },
    wxLoginWap(data) {
        return axios.request({
            url: "user/login-wx-wap",
            method: "post",
            data
        });
    },
    appLaunch() {
        return axios.request({
            url: "api/launch"
        })
    },
    upload({content, imgkey}) {

        var formData = new FormData();
        var arr = content.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        if (!imgkey) imgkey = 'myfile'
        let mime2siffix = {
            'video/x-msvideo': 'avi',
            'video/x-dv': 'dv',
            'video/quicktime': 'mov',
            'video/x-ms-wmv': 'wm',
            'video/x-flv': 'flv',
            'video/x-matroska': 'mkv'
        };
        let suffix = mime2siffix[mime]
        if (!suffix) suffix = mime.split('/')[1]

        formData.append(imgkey, new File([u8arr], `${imgkey}.${suffix}`, {type: mime}));
        formData.append("imgkey", imgkey);
        formData.append("name", imgkey);


        return axios.request({
            url: "api/fileupload",
            method: "post",
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            transformRequest: [
                function (data) {
                    return data
                }
            ],
            timeout: 10e4
        })
    },
    getVersion(){
        return axios.request({
            baseURL: "",
            url: `/static/json/version.json?v=${new Date().getTime().toString()}`,
            method: "get",
            params:{'api_throw_exception':false}
        })
    },
    join(data) {
        return axios3.request({
            url: "lottery/join",
            method: "post",
            data
        });
    },
    getLive(data) {
        return axios.request({
            url: "live/index",
            method: "post",
            data
        }).then(res=>{
            if(res.status === 200) {
                res.data.forEach(item=>{
                    switch(item.live_status*1){
                        case 101:
                            item.statename = '直播中'
                            item.color = '#FE7C11'
                            break;
                        case 102:
                            item.statename = '未开始'
                            item.color = '#333333'
                            break;
                        case 103:
                            item.statename = '可回放'
                            item.color = '#333333'
                            break;
                        case 104:
                            item.statename = '禁播'
                            item.color = '#333333'
                            break;
                        case 105:
                            item.statename = '暂停'
                            item.color = '#333333'
                            break;
                        case 0:
                        case 106:
                            item.statename = '异常'
                            item.color = '#333333'
                            break;
                        case 107:
                            item.statename = '已过期'
                            item.color = '#333333'
                            break;
                    }
                })
                    
            }
            return res;
        });
    }
}
